import { axiosAction } from "../../utils/axiosAction";
import { MODELS_FETCH_MODELS } from "../action-types/models-types";

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_MODELS}`;

export const getEntities =
  (params: any = {}, meta?) =>
  async dispatch => {
    return axiosAction.get(ENDPOINT, MODELS_FETCH_MODELS, dispatch, { params, meta });
  };
